module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiBmaWxsPSJub25lIiB2ZXJzaW9uPSIxLjEiIHdpZHRoPSI0NCIgaGVpZ2h0PSIyNiIgdmlld0JveD0iMCAwIDQ0IDI2Ij48Zz48cGF0aCBkPSJNMCwxM0MwLDIwLjE3OTcwMyw1LjgyMDI5NjgsMjYsMTIuOTk5OTk4LDI2TDQ0LDI2TDQ0LDBMMTIuOTk5OTk5LDBDNS44MjAyOTY4LDAsMCw1LjgyMDI5NzcsMCwxM1oiIGZpbGw9IiMwMDAwMDAiIGZpbGwtb3BhY2l0eT0iMC4zMDAwMDAwMTE5MjA5Mjg5NiIvPjwvZz48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./static/image/activityManage/rulesImage.svg
// module id = a+TO
// module chunks = 1